const hotels = {
  accommodation: "Akomodasyon", // translated 
  hotel: "Hotel", // translated 
  hotels: "Mga Hotel", // translated 
  back: "Balik", // translated 
  rooms: "Mga Kwarto", // translated 
  viewPictures: "Tingnan ang mga Larawan", // translated 
  showMore: "magpakita pa", // translated 
  bookingInformation: "Impormasyon sa Pag-book", // translated 
  importantInformation: "Mahalagang Impormasyon", // translated
  cancellationPolicy: "Patakaran sa Pagkansela", // translated 
  from: "Mula sa", // translated 
  to: "Προς την", // translated 
  cancellationIs: "ang pagkansela ay", // translated 
  free: "libre", // translated 
  chargeableWithFeeOf: "may bayad na", // translated 
  prebook: "Prebook", // translated 
  guests: "Mga Bisita", // translated 
  payment: "Pagbabayad", // translated 
  byClicking: "Sa pamamagitan ng pag-click", // translated 
  next: "Susunod", // translated 
  youAreAgreeingToOur: "sumasang-ayon ka sa aming", // translated 
  termsAndConditions: "Mga Tuntunin at Kundisyon", // translated 
  previous: "Nakaraan", // translated 
  cancel: "Kanselahin", // translated 
  mealPlan: "Plano ng Pagkain", // translated 
  roomType: "Uri ng Kwarto", // translated 
  description: "Paglalarawan", // translated 
  readLess: "Magbasa nang Mas kaunti", // translated 
  readMore: "Magbasa Pa", // translated 
  facilities: "Mga Pasilidad", // translated 
  viewLess: "Tingnan ang Mas Kaunting", // translated 
  viewMore: "Tingnan ang Higit Pa", // translated 
  less: "mas kaunti", // translated 
  more: "higit pa", // translated 
  notAvailable_short: "Wala", // translated 
  backToHotelList: "Bumalik sa listahan ng hotel", // translated 
  viewOnMap: "Tingnan sa mapa", // translated 
  sleeps: "Natutulog", // translated 
  adults: "Mga Matanda", // translated 
  yearsOld: "taong gulang", // translated 
  type: "Uri", // translated 
  bedding: "Mga higaan", // translated 
  selectRoom: "Pumili ng Silid", // translated 
  selectRooms: "Pumili ng mga Kwarto", // translated 
  city: "Lungsod", // translated 
  checkIn: "Mag-check in", // translated 
  checkOut: "Mag-check Out", // translated 
  date: "Petsa", // translated 
  dates: "Mga Petsa", // translated 
  persons: "Mga Tao", // translated 
  stillOnTrialQuestionToUpgrade:
    "Naku! Mukhang nasa trial membership ka pa rin. Kailangan mong maging kumpirmadong miyembro para makapag-book. Gusto mo bang mag-upgrade ngayon?", // translated 
  stillOnTrialQuestionToUpgradeNonElligib:
    "Naku! Mukhang hindi ka pa naka-subscribe. Kailangan mong maging kumpirmadong miyembro para makapag-book. Gusto mo bang mag-upgrade ngayon?", // translated 
  completeProfile: "Pakikumpleto muna ang iyong user profile", // translated 
  upgrade: "Αναβαθμίζω", // translated 
  close: "Isara", // translated 
  viewDetails: "Tingnan ang mga Detalye", // translated 
  name: "Pangalan", // translated 
  rating: "Rating", // translated 
  budget: "Badyet", // translated 
  orderBy: "Umorder Ayon sa", // translated 
  priceLowestFirst: "Presyo (pinakamababa muna)", // translated 
  priceHighestFirst: "Presyo (pinakamataas muna)", // translated 
  ratingLowestFirst: "Rating (pinakamababa muna)", // translated 
  ratingHighestFirst: "Rating (pinakamataas muna)", // translated 
  starRatingAndPrice: "Rating ng Bituin at Presyo", // translated 
  biggestSavingsFirst: "Pinakamalaking Pagtitipid Una", // translated 
  select: "Piliin", // translated 
  reset: "I-reset", // translated 
  apply: "Mag-apply", // translated 
  filterBy: "Salain ayon sa", // translated 
  myProfile: "Aking Profile", // translated 
  login: "Mag-login", // translated 
  roomOnly: "Kwarto Lamang", // translated 
  bedAndBreakfast: "Kama at Almusal", // translated 
  halfBoard: "Kalahating Lupon", // translated 
  fullBoard: "Buong Lugar", // translated 
  allInclusive: "Lahat Kasama", // translated 
  filter: "Salain", // translated 
  mapView: "Tingnan ang Mapa", // translated 
  results: "mga resulta", // translated 
  listView: "Tingnan ang Listahan", // translated 
  newSearch: "Bagong Paghahanap", // translated 
  editSearch: "I-edit ang Paghahanap", // translated 
  all: "Lahat", // translated 
  multiple: "Maramihan", // translated 
  editProfile: "I-edit ang Profile", // translated 
  backToHotelsList: "Bumalik sa Listahan ng mga Hotel", // translated 
  roomName: "Pangalan ng Kwarto", // translated 
  mealType: "Uri ng Pagkain", // translated 
  freeCancellation: "Libreng Pagkansela", // translated 
  yes: "Oo", // translated 
  no: "Opisyal", // translated 
  filters: "Mga Filter", // translated 
  cancellationNonRefundable: "Hindi maibabalik ang bayad sa pagkansela", // translated 
  hotelRating: "Rating ng Hotel", // translated 
  any: "Kahit ano", // translated 
  off: "Patay", // translated 
  performNewSearch: "Magsagawa ng bagong paghahanap", // translated 
};


export default hotels;
